import styled from 'styled-components'

export const Title = styled.h2`
	margin: 0;
`
